import { render, staticRenderFns } from "./downloadListPage.vue?vue&type=template&id=c54b3a8a&"
import script from "./downloadListPage.vue?vue&type=script&lang=ts&"
export * from "./downloadListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports